import React from "react";

const DarkBlueButton = ({
  name,
  handleClick,
  className,
  textStyle,
  type,
  disabled = false,
  isLoading = false,
}: {
  name: string;
  handleClick?: (e?: any) => void;
  className?: string;
  textStyle?: string;
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;
  isLoading?: boolean;
}) => {
  return (
    <button
      className={`rounded-lg bg-sbTextHover px-4 py-2 text-white hover:bg-[#0F3CBE] mr-3 focus:outline-none disabled:cursor-not-allowed flex items-center justify-center ${
        className ? className : ""
      }`}
      disabled={disabled || isLoading}
      type={type ? type : "button"}
      onClick={handleClick}
    >
      {isLoading ? (
        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
      ) : (
        <p className={`${textStyle ? textStyle : ""}`}>{name}</p>
      )}
    </button>
  );
};

export default DarkBlueButton;
